<div *ngIf="formInfo" class="container-fluid pl-0">
    <div class="mb-4 form-label">
        <span>{{ formInfo.name | translate }}</span>
    </div>
    <form [formGroup]="form">
        <div class="row">
            <div
                *ngFor="let field of formInfo.fields"
                class="form-group mb-3"
                [ngClass]="{
                    'form-group  col-2': field.columns === formWidthCol2,
                    'col-xl-3 col-lg-4 col-md-6 col-12': field.columns === formWidthCol3,
                    'col-xl-4 col-md-6 col-12': field.columns === formWidthCol4,
                    'col-md-6 col-12': field.columns === formWidthCol6,
                    'col-lg-8 col-12': field.columns === formWidthCol8,
                    'col-lg-9 col-12': field.columns === formWidthCol9,
                    'col-lg-10 col-12': field.columns === formWidthCol10,
                    'col-12': field.columns === formWidthCol12,
                    'offset-2': field.columnsOffset === formWidthOffsetCol2,
                    'offset-3': field.columnsOffset === formWidthOffsetCol3,
                    'offset-4': field.columnsOffset === formWidthOffsetCol4,
                    'offset-6': field.columnsOffset === formWidthOffsetCol6,
                    'offset-8': field.columnsOffset === formWidthOffsetCol8,
                    'offset-10': field.columnsOffset === formWidthOffsetCol10
                }"
            >
                <div *ngIf="field.active">
                    <label class="mb-0">
                        {{ field.label | translate }}
                        <span *ngIf="checkMandatory(field)">*</span>
                        <span *ngIf="field.type === formTypePhone">{{ "PHONE_VALIDATOR_LABEL" | translate }}</span>
                    </label>
                    <ng-multiselect-dropdown
                        *ngIf="field.type === formTypeMultiSelect"
                        [placeholder]="field.placeholder | translate"
                        [data]="field.values"
                        [(ngModel)]="field.selectedValue"
                        [settings]="field.dropdownSettings"
                        formControlName="{{ field.formControlName }}"
                    >
                    </ng-multiselect-dropdown>
                    <div *ngIf="field.type === formTypeFile">
                        <input
                            type="file"
                            [multiple]="field.multipleFiles"
                            placeholder="{{ 'FORM_COMPONENT_UPLOAD_FILE' | translate }}"
                            formControlName="{{ field.formControlName }}"
                            class="py-1"
                            (change)="fileChange($event, field.formControlName)"
                            [accept]="field.acceptedExtensions"
                        />
                    </div>
                    <input
                        *ngIf="field.type === formTypeText"
                        class="form-control rounded-1"
                        [placeholder]="field.placeholder | translate"
                        [ngClass]="{
                            'is-invalid':
                                (form.get(field.formControlName).touched || form.get(field.formControlName).dirty) &&
                                !form.get(field.formControlName).valid
                        }"
                        formControlName="{{ field.formControlName }}"
                        [readonly]="!field.enabled"
                    />
                    <input
                        type="number"
                        step="1"
                        *ngIf="field.type === formTypeInt"
                        class="form-control rounded-1"
                        [ngClass]="{
                            'is-invalid':
                                (form.get(field.formControlName).touched || form.get(field.formControlName).dirty) &&
                                !form.get(field.formControlName).valid
                        }"
                        formControlName="{{ field.formControlName }}"
                        [readonly]="!field.enabled"
                    />
                    <input
                        type="checkbox"
                        *ngIf="field.type === formTypeCheckbox"
                        class="form-check-input"
                        style="margin-left: 10px;"
                        formControlName="{{ field.formControlName }}"
                    />
                    <input
                        type="number"
                        min="0"
                        step="1"
                        *ngIf="field.type === formTypeIntPositive"
                        class="form-control rounded-1"
                        [ngClass]="{
                            'is-invalid':
                                (form.get(field.formControlName).touched || form.get(field.formControlName).dirty) &&
                                !form.get(field.formControlName).valid
                        }"
                        formControlName="{{ field.formControlName }}"
                        [readonly]="!field.enabled"
                    />
                    <input
                        type="email"
                        *ngIf="field.type === formTypeEmail"
                        class="form-control rounded-1"
                        [ngClass]="{
                            'is-invalid':
                                (form.get(field.formControlName).touched || form.get(field.formControlName).dirty) &&
                                !form.get(field.formControlName).valid
                        }"
                        formControlName="{{ field.formControlName }}"
                        [readonly]="!field.enabled"
                    />
                    <input
                        type="tel"
                        *ngIf="field.type === formTypePhone"
                        class="form-control rounded-1"
                        [ngClass]="{
                            'is-invalid':
                                (form.get(field.formControlName).touched || form.get(field.formControlName).dirty) &&
                                !form.get(field.formControlName).valid
                        }"
                        formControlName="{{ field.formControlName }}"
                        [readonly]="!field.enabled"
                    />
                    <input
                        type="password"
                        *ngIf="field.type === formTypePassword"
                        class="form-control rounded-1"
                        [ngClass]="{
                            'is-invalid':
                                (form.get(field.formControlName).touched || form.get(field.formControlName).dirty) &&
                                !form.get(field.formControlName).valid
                        }"
                        formControlName="{{ field.formControlName }}"
                        [readonly]="!field.enabled"
                    />
                    <input
                        type="time"
                        step="{{ inputTimeStep }}"
                        *ngIf="field.type === formTypeTime"
                        class="form-control rounded-1"
                        [ngClass]="{
                            'is-invalid':
                                (form.get(field.formControlName).touched || form.get(field.formControlName).dirty) &&
                                !form.get(field.formControlName).valid
                        }"
                        formControlName="{{ field.formControlName }}"
                        [readonly]="!field.enabled"
                    />
                    <input
                        *ngIf="field.type === formTypeDate"
                        class="form-control date rounded-1"
                        [ngClass]="{
                            'is-invalid':
                                (form.get(field.formControlName).touched || form.get(field.formControlName).dirty) &&
                                !form.get(field.formControlName).valid
                        }"
                        formControlName="{{ field.formControlName }}"
                        #date
                        [placeholder]="field.placeholder | translate"
                        (focus)="date.type = 'date'; date.style.backgroundImage = 'none'"
                        (focusout)="
                            date.type = 'text'; date.style.backgroundImage = 'url(' + 'assets/img/calendar.png' + ')'
                        "
                        [ngStyle]="{ 'background-image': 'url(' + 'assets/img/calendar.png' + ')' }"
                        [readonly]="!field.enabled"
                    />
                    <ng-select
                        *ngIf="field.type === formTypeSelect2"
                        class="rounded-1"
                        (change)="onChange(field)"
                        [items]="field.values"
                        bindLabel="text"
                        bindValue="id"
                        [searchable]="true"
                        [placeholder]="field.placeholder | translate"
                        [ngClass]="{
                            'is-invalid':
                                (form.get(field.formControlName).touched || form.get(field.formControlName).dirty) &&
                                !form.get(field.formControlName).valid
                        }"
                        formControlName="{{ field.formControlName }}"
                    ></ng-select>
                    <input
                        type="datetime-local"
                        *ngIf="field.type === formTypeDatetime"
                        class="form-control rounded-1"
                        [ngClass]="{
                            'is-invalid':
                                (form.get(field.formControlName).touched || form.get(field.formControlName).dirty) &&
                                !form.get(field.formControlName).valid
                        }"
                        formControlName="{{ field.formControlName }}"
                        [readonly]="!field.enabled"
                    />
                    <select
                        *ngIf="field.type === formTypeSelect"
                        class="form-control rounded-1"
                        (change)="onChange(field)"
                        [ngClass]="{
                            'is-invalid':
                                (form.get(field.formControlName).touched || form.get(field.formControlName).dirty) &&
                                !form.get(field.formControlName).valid
                        }"
                        formControlName="{{ field.formControlName }}"
                    >
                        <option *ngIf="field.placeholder" disabled [ngValue]="null" [selected]="true">
                            {{ field.placeholder | translate }}
                        </option>
                        <option *ngFor="let value of field.values" [ngValue]="value.id">
                            {{ value.text | translate }}
                        </option>
                    </select>
                    <textarea
                        *ngIf="field.type === formTypeTextarea"
                        rows="4"
                        class="form-control rounded-1"
                        [ngClass]="{
                            'is-invalid':
                                (form.get(field.formControlName).touched || form.get(field.formControlName).dirty) &&
                                !form.get(field.formControlName).valid
                        }"
                        formControlName="{{ field.formControlName }}"
                        [readOnly]="!field.enabled"
                    ></textarea>
                    <button
                        *ngIf="field.button"
                        class="btn px-3 py-1 my-2 w-100 rounded"
                        [ngStyle]="{ 'background-color': field.button.color }"
                        (click)="field.button.callback(field.formControlName)"
                    >
                        <span [ngStyle]="{ color: field.button.fontColor }">{{ field.button.label | translate }}</span>
                    </button>
                    <small class="form-text text-muted" *ngIf="field.infoText">{{ field.infoText | translate }}</small>
                    <div class="invalid-feedback" *ngIf="field.invalidText">
                        {{ field.invalidText | translate }}
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
